import React from "react";
import ServiceHero from "../sections/ServiceHero";
import ServiceSection from "../sections/ServiceSection";
import Reason from "../sections/Reason";
import ContactSection from "../sections/ContactSection";
import Team from "../sections/Team";

const Service = () => {
  return (
    <div>
      <ServiceHero />
      <ServiceSection />
      <Team />
      <Reason />
      <ContactSection />
    </div>
  );
};

export default Service;
